import React from 'react';
import CustomCarousel from '../../../shared/CustomCarousel/CustomCarousel';
import Section from '../../../shared/Section/Section';
import { Grid, Typography } from '@mui/material';
const PATH = 'about';

export default function Atmosphere({ title, images, slides, description }) {
  return (
    <Section title={title} withoutBg>
      <Grid container>
        <Grid item xs={12} lg={6}>
          <Typography variant="desktopP1" color={'kit.text.secondary'}>
            {description}
          </Typography>
        </Grid>
      </Grid>
      <CustomCarousel
        slides={slides?.map((slide) => ({
          path: images[`${PATH}/${slide.image}`],
        }))}
      />
    </Section>
  );
}
